import { createSlice } from '@reduxjs/toolkit';

import type { EscritorioMembrosState } from '@/types/escritorio/escritorioTypes';

import { listarMembros, removerMembro, toggleStatusMembro, updatePapelMembro } from './actions';

const initialState: EscritorioMembrosState = {
  membros: [],
  isLoading: false,
  error: null,
  loadedEscritorioId: null,
};

const escritorioMembrosSlice = createSlice({
  name: 'escritorioMembros',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearMembros: (state) => {
      state.membros = [];
      state.loadedEscritorioId = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(listarMembros.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(listarMembros.fulfilled, (state, action) => {
        state.isLoading = false;
        state.membros = action.payload;
        state.loadedEscritorioId = action.meta.arg.escritorioId;
      })
      .addCase(listarMembros.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
        state.loadedEscritorioId = action.meta.arg.escritorioId;
      })

      .addCase(updatePapelMembro.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updatePapelMembro.fulfilled, (state, action) => {
        state.isLoading = false;
        const index = state.membros.findIndex((m) => m.id === action.payload.id);
        if (index !== -1) {
          state.membros[index] = action.payload;
        }
      })
      .addCase(updatePapelMembro.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      })

      .addCase(toggleStatusMembro.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(toggleStatusMembro.fulfilled, (state, action) => {
        state.isLoading = false;
        const index = state.membros.findIndex((m) => m.id === action.payload.id);
        if (index !== -1) {
          state.membros[index] = action.payload;
        }
      })
      .addCase(toggleStatusMembro.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      })

      .addCase(removerMembro.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(removerMembro.fulfilled, (state, action) => {
        state.isLoading = false;
        state.membros = state.membros.filter((m) => m.id !== action.payload);
      })
      .addCase(removerMembro.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      });
  },
});

export default escritorioMembrosSlice.reducer;
